const wow = {
	state: {
		loaded: false,
		scripts: {},
		scriptsLoaded: false,
		count: 0,
		init: false
	},
	button: jQuery('.dmfw--document'),
	container: "",
	innerContainer: null,
	closeControl: jQuery(wow_book_vars.icons.cross),
	leftControl: jQuery(wow_book_vars.icons.arrow_left),
	rightControl: jQuery(wow_book_vars.icons.arrow_right),
	downloadControl: jQuery('<a download class="hpy-download-pdf" href="null">' + wow_book_vars.icons.download + '<span>DOWNLOAD PDF</span></a>'), // Blank download link
	printControl: jQuery('<div class="hpy-print-pdf">' + wow_book_vars.icons.print + '<span>PRINT PDF</span></div>'),

	init: () => {
		if (!wow_book_vars || !wow_book_vars.scripts || wow.state.init) {
			console.log('WOW BOOK: Already initialized or no scripts to load');
			return;
		}

		console.log('LOAD WOW BOOK');

		wow.state.init = true;

		wow.countScripts();
		wow.loadScript(0);
	},
	loadScript: (index) => {
		let script = wow_book_vars.scripts[index];

		wow.state.scripts[script.key] = false;

		let tag = document.createElement('script');
		tag.setAttribute('type', 'text/javascript');
		tag.setAttribute('defer', 'defer');
		tag.setAttribute('async', 'async');
		tag.setAttribute('src', script.url);
		tag.onload = () => wow.onload(index, script.key);

		console.log('WOW BOOK: ADD SCRIPT ' + script.url);

		document.body.appendChild(tag);
	},
	onload: (index, key) => {
		wow.state.scripts[key] = true;
		if (index < wow.state.count - 1) {
			wow.loadScript(++index);
			return;
		}

		for (let script in wow.state.scripts) {
			if (!wow.state.scripts[script]) return;
		}

		wow.state.scriptsLoaded = true;
		wow.showButton();
		wow.setupEvents();
	},
	countScripts: () => {
		for (let i in wow_book_vars.scripts) {
			wow.state.count++;
		}
	},
	showButton: () => {
		wow.button.css({
			opacity: 1,
			pointerEvents: 'auto',
		});
	},
	setupEvents: () => {
		jQuery(document).on('keyup', function (e) {
			if (e.keyCode == 27) {
				wow.quitBookPreview();
			}
		});

		jQuery('body')
			.on('click', '.book_container .icon-arrow-right', function () {
				jQuery('.wowbook-control-right').trigger('click');
			})
			.on('click', '.book_container .icon-arrow-left', function () {
				jQuery('.wowbook-control-left').trigger('click');
			})
			.on('click', '.book_container svg.icon-cross-icon', function () {
				wow.quitBookPreview();
			})
			.on('click', '.book_container .hpy-print-pdf', function () {
				let pdfURL = jQuery('.hpy-download-pdf').attr('href');
				let pdfWindow = window.open(pdfURL);
				// Timeout fixes problem in Firefox
				pdfWindow.addEventListener('load', () => setTimeout(function () {
					pdfWindow.print();
				}, 200));
			});

		wow.button.on('click', wow.wowBook);

		/* Unhide Documentation Tiles once loaded */
		jQuery('.bjc-product-tile').css('visibility', 'visible');
	},
	wowBook: function (e) {
		console.log('WOW BOOK: BUTTON CLICKED');
		e.preventDefault();

		if (typeof PDFJS == 'undefined') {
			console.warn('PDFJS not loaded');
			return;
		}

		let _this = jQuery(this);
		let imgLocation = _this.attr('href');

		jQuery(wow.downloadControl).attr('href', imgLocation); // Set download button href to loaded PDF

		wow.init_book_container();

		var bookOptions = {
			pdf: imgLocation,
			pdfFind: true,
			maxwidth: '100%',
			height: 500,
			width: 800,
			centeredWhenClosed: true,
			hardcovers: true,
			toolbar: 'lastLeft, left, right, lastRight, zoomin, zoomout',
			toolbarPosition: 'top',
			responsiveHandleWidth: 100,
			container: window,
			containerPadding: '5%',
			flipSound: false,
			pageNumbers: false,
			onShowPage: function () {
				if (!wow.state.loaded) {
					wow.state.loaded = true;
					wow.innerContainer = wow.container.find('.wowbook-book-container');

				}
			},
			updateBrowserURL: false,
		};

		jQuery('#wowbook-container').wowBook(bookOptions);

		wow.fadeInBook();

		return false;
	},
	init_book_container: function () {
		let pdfSaveButtons = jQuery('<div class="hpy-pdf-save-buttons"></div>');

		pdfSaveButtons.append(wow.downloadControl);
		console.log(wow.isSafari())
		if (!wow.isSafari()) {
			pdfSaveButtons.append(wow.printControl);
		}


		if (!wow.container.length) {
			wow.container = jQuery('<div class="book_container" style="display:none"><div id="wowbook-container"></div></div>')
				.append(wow.closeControl)
				.append(wow.leftControl)
				.append(wow.rightControl)
				.append(pdfSaveButtons)
			jQuery('body').append(wow.container);
		}
	},
	isSafari: function () {
		var result = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		return !!result;
	},
	// show(complete) {

	// }

	// hide(complete) {
	// 	gsap.to(this.data.element, {
	// 		opacity: 0,
	// 		display: "none",
	// 		duration: 0.3,
	// 		onComplete: () => {
	// 			this.data.shown = true;
	// 			if (complete)
	// 				complete();
	// 		}
	// 	});
	// }
	fadeInBook: function () {

		gsap.set(wow.container, { display: 'none', opacity: 0 });
		gsap.set(wow.innerContainer, { display: 'none', opacity: 0, y: 10 });
		console.log(wow)
		gsap.to(wow.container, {
			opacity: 1,
			duration: 0.3,
			onStart: function () {
				wow.container.show();
			},
			onComplete: function () {
				gsap.to(wow.innerContainer, {
					opacity: 1,
					duration: 0.3,
					onStart: function () {
						wow.innerContainer.show();
					},
					onComplete: function () {
						jQuery(window).trigger('resize');
					}
				});

			}
		});

		// wow.container.velocity('transition.fadeIn', {
		// 	duration: 300,
		// 	easing: 'easeInQuad',
		// 	complete: function () {
		// 		wow.innerContainer.velocity('transition.slideUpIn', { duration: 300, easing: 'easeInQuad' });
		// 	},
		// });
	},
	quitBookPreview: function () {

		gsap.to(wow.container, {
			opacity: 0,
			display: "none",
			duration: 0.3,
			onComplete: () => {
				// wow.innerContainer.css({ opacity: 1 });

				// Clear previous wowbook to allow for switch to a different pdf
				jQuery(".book_container").remove();
				wow.container = "";
			}
		});
		wow.state.loaded = false;
	},
};

function maybeLoadWoWBook() {
	wow.init();
}

maybeLoadWoWBook();
document.addEventListener('DOMContentLoaded', maybeLoadWoWBook);
window.addEventListener('load', maybeLoadWoWBook);